import { Predicate } from '~/types/Predicate';

export const and =
  <T>(predicates: Predicate<T>[]) =>
  (x: T): boolean => {
    if (predicates.length < 1) {
      return false;
    }

    return predicates.reduce((bool: boolean, predicate: Predicate<T>) => {
      return bool && predicate(x);
    }, true);
  };
